import axios from "axios";

class OrderService {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL || "https://api.almasecret.msit-demo.fr";
  }

  // Get all orders for a specific user
  async getUserOrders(userId) {
    try {
      const response = await axios.get(`${this.baseURL}/orders/user/${userId}`, {
        withCredentials: true, // Include cookies for authentication
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching user orders:", error);
      throw error;
    }
  }

  // Get order details by ID
  async getOrderById(orderId) {
    try {
      const response = await axios.get(`${this.baseURL}/orders/${orderId}`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching order details:", error);
      throw error;
    }
  }

  // Create a new order
  async createOrder(orderData) {
    try {
      const response = await axios.post(`${this.baseURL}/orders`, orderData, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating order:", error);
      throw error;
    }
  }

  // Update order status
  async updateOrderStatus(orderId, status) {
    try {
      const response = await axios.patch(
        `${this.baseURL}/orders/${orderId}/status`,
        { status },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating order status:", error);
      throw error;
    }
  }

  // Cancel an order
  async cancelOrder(orderId) {
    try {
      const response = await axios.patch(
        `${this.baseURL}/orders/${orderId}/cancel`,
        {},
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error canceling order:", error);
      throw error;
    }
  }
}

export default OrderService;